import { useConfigContext } from '../config-context';
import { ConfigContextValue } from '../config-context.types';

export const useConfigContextGuard = (): ConfigContextValue => {
  const contextValue = useConfigContext();
  if (!contextValue.config) {
    throw new Error('useConfig can not be used before ConfigContext is initialized');
  }

  return contextValue;
};
